exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#fileInput{display:none}.video-centered{overflow:hidden;width:100%;align-items:center}", ""]);

// exports
